var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAppstore = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,32H5.016a5,5,0,0,1-5-5V5a5.01,5.01,0,0,1,5-5h22a5,5,0,0,1,5,5v9a1,1,0,0,1-2,0V5a3,3,0,0,0-3-3h-22a3.007,3.007,0,0,0-3,3V27a3,3,0,0,0,3,3H14a1,1,0,0,1,0,2Z",
    transform: "translate(-1.018 -1)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.5a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V11.5A1,1,0,0,1,0,12.5Z",
    transform: "translate(23.982 18.5)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12a1,1,0,0,1,1,1A1,1,0,0,1,12,1Z",
    transform: "translate(17.982 24)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,2V7H7V2H2M2,0H7A2,2,0,0,1,9,2V7A2,2,0,0,1,7,9H2A2,2,0,0,1,0,7V2A2,2,0,0,1,2,0Z",
    transform: "translate(8.482 2.136) rotate(45)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,2A2.5,2.5,0,1,0,7,4.5,2.5,2.5,0,0,0,4.5,2m0-2A4.5,4.5,0,1,1,0,4.5,4.5,4.5,0,0,1,4.5,0Z",
    transform: "translate(16.982 4)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,2V7H7V2H2M2,0H7A2,2,0,0,1,9,2V7A2,2,0,0,1,7,9H2A2,2,0,0,1,0,7V2A2,2,0,0,1,2,0Z",
    transform: "translate(3.982 17)",
    fill: "current"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppstore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/appstore.d08cfc22.svg";
export { ForwardRef as ReactComponent };